import React from "react";
import "./organizationMembersListRow.css";
import EditIcon from "../../../svgs/icoMoon/icons/edit/editIcon";
import UsersIcon from "../../../svgs/icoMoon/icons/users/usersIcon";

import {
  MEMBER_DEFINITIONS,
  ROLE_DEFINITIONS,
} from "../../../../constants/organizationRoles";
import { ORGANIZATION_PERMISSION_ADMINISTER_MEMBERS } from "../../../../constants/organizationPermissions";
import OrganizationPermission from "../../organizationPermission/OrganizationPermission";

function OrganizationMembersListRow(props) {
  const { onEdit, userName, roles, status, uuid, invitationExpirationDate } =
    props;

  // Check if invitation has expired
  const isExpired =
    invitationExpirationDate && new Date() > new Date(invitationExpirationDate);
  const statusName =
    MEMBER_DEFINITIONS.find((def) => def.id === status)?.name || status;

  // Build status display text
  const statusDisplay =
    isExpired && status === "pending_invitation"
      ? `${statusName} (Expired)`
      : statusName;

  return (
    <li className="row line" key={uuid}>
      <div className="cell forum" data-title="MEMBER NAME">
        <div className="arr_line_1" style={{ wordBreak: "break-word" }}>
          <UsersIcon />
          {" " + userName}
        </div>
      </div>
      <div className="cell tr_white topic" data-title="STATUS">
        {statusDisplay}
      </div>
      <div className="cell tr_white posts" data-title="ROLE">
        {roles
          .filter((role) => ROLE_DEFINITIONS.find((r) => r.id === role))
          .map((role) => ROLE_DEFINITIONS.find((r) => r.id === role).name)
          .join(", ")}
      </div>
      <div className="cell tr_white posts" data-title="EDIT">
        <OrganizationPermission
          allowedPermissions={[ORGANIZATION_PERMISSION_ADMINISTER_MEMBERS]}
        >
          <div onClick={() => onEdit(uuid)}>
            <EditIcon />
          </div>
        </OrganizationPermission>
      </div>
    </li>
  );
}

export default OrganizationMembersListRow;
